module.exports = __webpack_public_path__ + "static/media/expressive1.9c7d50b4.png";